import bbobReactRender from "@bbob/react/es/render";
import { bbobExtendedReactPreset, ALLOWED_BBCODE_TAGS } from "@lib/bbobExtendedReactPreset";

const formatText = text => {
  if (text) {
    return bbobReactRender(text, bbobExtendedReactPreset(), {
      onlyAllowTags: ALLOWED_BBCODE_TAGS,
    });
  }
};

const useTextFormatter = () => {
  return formatText;
};

export { useTextFormatter };
